<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

/** `audio_response` carries no fields, so no props and no attribute inheritance — one honest
 *  sentence instead of an empty box. Same shape as `InteractionOpenEnded`. */
defineOptions({
  name: 'InteractionAudioResponse',
  inheritAttrs: false,
})
</script>

<template>
  <AppText
    class="interaction-audio-response"
    name="body2"
    color="slate-500"
  >
    The kid records a spoken response. There is nothing to author here — the prompt lives in this
    activity's content blocks above.
  </AppText>
</template>

<style scoped lang="scss" src="./InteractionAudioResponse.scss" />
